<template>
  <div>
    <vx-card>
      <lista-notificacoes
        :subjectPermission="subjectPermission"
      ></lista-notificacoes>
    </vx-card>
  </div>
</template>

<script>
import listaNotificacoes from './listaNotificacoes';

export default {
  data() {
    return {
      subjectPermission: 'Listar Notificações',
    };
  },
  methods: {},
  components: {
    listaNotificacoes,
  },
};
</script>
